/**!
 * Created by Leonardo Cheslacki on 17/07/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import {HelpersPin} from './../helpers';

import config from '../../../../config';

const {default: {domain, routes: {web}, view, text}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StageView extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        const {frame, pav, current_name} = this.props;

        this.state = {
            data: [] || {},
            bitmap: null,
            frame: frame,
            pav: pav,
            _this_frame_old: null
        };

        this.helpersPin = HelpersPin(this)({current_name: current_name});

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param number_current
         */
        handlePav: function (event, {number_current}) {
            _this.setState({..._this.state, pav: number_current}, () => {
                let
                    {frame, pav} = _this.state,
                    _this_current = _this.get(),
                    icon_current = `occ_icon_pav${_this.padWithLeadingZeros(number_current, 2)}`,
                    pseudo_current = `occ_pseudo_pav${_this.padWithLeadingZeros(number_current, 2)}`,
                    btn_current = `btn_pav${_this.padWithLeadingZeros(number_current, 2)}`,
                    children = _this_current.children,
                    product = _this.getProduct(frame, pav),
                    image = _this.verifyField(product, 'product.src').value;

                if (_this.isArrayIf(children)) {
                    for (let property of children) {
                        if (_this.hasString(property.name, 'occ_icon_pav')) {
                            property.occ_effect.occ_animate.visible = (property.name !== icon_current);
                        }

                        if (_this.hasString(property.name, 'occ_pseudo_pav')) {
                            property.visible = (property.name === pseudo_current);
                        }

                        if (_this.hasString(property.name, 'btn_pav')) {
                            property.visible = (property.name !== btn_current);
                        }
                    }
                }

                _this.setImage(`${_this.$base_uri}/${web.uri_images}/${image}`);
            });
        }
    };

    /**
     *
     * @param frame
     * @param pav
     * @returns {*}
     */
    getProduct = (frame, pav) => {
        let
            {data} = this.state,
            array = data.filter((value) => {
                return (
                    (this.verifyField(value, 'product.frame').value.toString() === frame.toString()) &&
                    (this.verifyField(value, 'product.pav').value.toString() === pav.toString())
                );
            });
        return this.firstArray(array);
    };

    /**
     *
     * @param uri
     */
    setImage = (uri) => {
        const {bitmap, _this_frame_old} = this.state;

        if (this.getObject(_this_frame_old, 'occ_view')) {
            bitmap && _this_frame_old.occ_view.removeChild(bitmap);
        }

        let {occ_view} = this.getFrame();

        bitmap && occ_view.removeChild(bitmap);

        this.state.bitmap = (new createjs.Bitmap(uri));

        this.state.bitmap.image.onload = () => {
            occ_view.addChild(this.state.bitmap);
        }
    };

    setTextPav = () => {
        const
            {frame} = this.state,
            {text: {color_text, font, font_size, weight, text_y}} = this.props,
            {children} = this.get();

        if (this.isArrayIf(children)) {
            for (let property of children) {
                if (this.hasString(property.name, 'occ_text_pav')) {
                    let product = this.getProduct(frame, this.toNumber(property.name));

                    !this.verifyField(property, 'state.original') && this.setStateOccurrence(property, {original: {y: property.y}});

                    let y = property.state.original.y + text_y;

                    this.helpersPin.setText(property, this.verifyField(product, 'product.text').value, color_text, font, font_size, weight, null, y, false);
                }
            }
        }
    };

    startView = () => {
        const
            _this_current = this.get(),
            children = _this_current.children,
            {current_name} = this.props;

        if (this.isArrayIf(children)) {
            for (let property of children) {
                let name = property.name;

                if (this.hasString(name, 'btn_pav')) {
                    let
                        number_current = this.toNumber(name),
                        occ = this.padWithLeadingZeros(number_current, 2),
                        handle_name = this.toHandleName(occ, 'paginate');

                    this[handle_name] && property.off('mousedown', this[handle_name]);
                    this[handle_name] = property.on('mousedown', this.$functions.handlePav, false, false, {
                        number_current: number_current
                    });
                }
            }
        }

        this.main.on('dynamic_paginate', ({number_current, _this_frame_old}) => {
            this.setState({...this.state, frame: number_current, _this_frame_old: _this_frame_old}, () => {
                let
                    {frame, pav} = this.state,
                    product = this.getProduct(frame, pav),
                    image = this.verifyField(product, 'product.src').value;

                this.setImage(`${this.$base_uri}/${web.uri_images}/${image}`);

                this.setTextPav();
            });
        }, current_name);
    };

    initView = () => {
        const {xml} = this.props;

        this.getForm(`${this.$base_uri || domain}/${web.uri_xml}/${xml}`, {}, {
            done: (response) => {
                let
                    object = this.firstArray(this.xmlToJson(response)),
                    products = this.getObject(object, 'products');

                this.setState({...this.state, data: products}, () => {
                    this.startView();
                    this.setTextPav();
                });
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                let
                    {frame, pav} = this.state,
                    product = this.getProduct(frame, pav),
                    image = this.verifyField(product, 'product.src').value;

                this.setImage(`${this.$base_uri}/${web.uri_images}/${image}`);
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StageView.propTypes = {
    current_name: PropTypes.string,
    xml: PropTypes.string,
    frame: PropTypes.number,
    pav: PropTypes.number,
    text: PropTypes.shape({
        color_text: PropTypes.string,
        font: PropTypes.string,
        font_size: PropTypes.number,
        weight: PropTypes.oneOf(['normal', 'bold'])
    }),
};

/**
 *
 * @type {{}}
 */
StageView.defaultProps = {
    current_name: null,
    ...view,
    text: {...view.text, ...text}
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StageView, {className: 'StageView'});
